import React from 'react';

const CommonProgressBar = ({ percentage, bgColor, barColor }) => {
  return (
    <div
      className="w-full bg-[#FF9BCB] relative rounded-full h-[6px]"
      style={{ background: bgColor }}
    >
      <div
        className="bg-[#F05289] h-2 rounded-full absolute top-[-1px]"
        style={{ width: `${percentage}%`, background: barColor }}
      ></div>
    </div>
  );
};

export default CommonProgressBar;
